module.exports = __webpack_public_path__ + "static/media/link.67bb6547.svg";